import { gql } from '@apollo/client';

const schema = {
  current: {
    name: 'moduleType',
    serviceName: 'graphql',
    query: gql`
      query moduleType($ids: [String]) {
        moduleType(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
